import CountryStore from '../flux/CountryStore';
import CountriesStore from '../flux/CountriesStore';

export default (id = CountryStore.getState()) => {
  const country = CountriesStore.find(id);

  if (country) {
    return country.currency_symbol;
  }

  console.warn('Cannot get currency symbol for current country', id, CountriesStore.getState());
  return null;
};



// WEBPACK FOOTER //
// ./src/utils/currencySymbol.js